import { ApiService } from "../api.service";
var ClashService = (function () {
    function ClashService(apiService) {
        this.apiService = apiService;
    }
    ClashService.prototype.getConfigByName = function (configName) {
        return this.apiService.loadConfig("./assets/config/clash/" + configName + ".json");
    };
    ClashService.prototype.getAllSceneList = function () {
        return this.getConfigByName("sceneList");
    };
    /*保存情景模拟的答题 */
    ClashService.prototype.saveExercisesAnswers = function (exerciseId, data) {
        return this.apiService.ajax({
            'type': 'post',
            'data': data,
            'url': '/sr/resolvingConflicts/saveExercisesAnswers'
        });
    };
    // 保存第三阶段情景模拟答题
    ClashService.prototype.saveStepThreeExercisesAnswers = function (exerciseId, data) {
        return this.apiService.ajax({
            'type': 'post',
            'data': data,
            'url': '/sr/resolvingConflicts/saveExercisesAnswersMult'
        });
    };
    /*保存进度 */
    ClashService.prototype.saveProgress = function (exerciseId, data) {
        return this.apiService.ajax({
            'type': 'post',
            'data': data,
            'url': '/sr/resolvingConflicts/saveProgress/' + exerciseId
        });
    };
    /*重做情景模拟 */
    ClashService.prototype.reset = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/resolvingConflicts/reset/' + exerciseId
        });
    };
    /* 获取当前步骤 */
    ClashService.prototype.getProgress = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/resolvingConflicts/getProgress/' + exerciseId
        });
    };
    /* 获取用户情景模拟决策树  */
    ClashService.prototype.getExercises = function (exerciseId, step) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/resolvingConflicts/exercises/' + exerciseId + '/' + step
        });
    };
    /* 获取用户情景模拟决策树第三阶段 */
    ClashService.prototype.getStepThreeExercises = function (exerciseId, step) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/resolvingConflicts/exercisesMult/' + exerciseId + '/' + step
        });
    };
    /* 获取用户解决冲突情景模拟决策树(历史回顾)  */
    ClashService.prototype.getExercisesHis = function (exerciseId, step) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/resolvingConflicts/exercisesHis/' + exerciseId + '/' + step
        });
    };
    /* 完成解决冲突情景模拟  */
    ClashService.prototype.finishExercises = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/resolvingConflicts/finish/' + exerciseId
        });
    };
    /* 获取用户解决冲突能力下的情景模拟列表  */
    ClashService.prototype.getPracticeList = function (learningPathId, practiceMetaId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/resolvingConflicts/createAndGet/' + learningPathId + '/' + practiceMetaId
        });
    };
    /* 保存解决冲突能力下的情景模拟保存点  */
    ClashService.prototype.setExerciseSavePoint = function (exerciseId, data) {
        return this.apiService.ajax({
            'type': 'post',
            'data': data,
            'url': '/sr/resolvingConflicts/saveMaxSceneReview'
        });
    };
    /* 获取解决冲突能力下的情景模拟保存点  */
    ClashService.prototype.getExerciseSavePoint = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/resolvingConflicts/getMaxSceneReview/' + exerciseId
        });
    };
    return ClashService;
}());
export { ClashService };



// WEBPACK FOOTER //
// ./src/app/case-practice-clash/ClashService.ts.pre-build-optimizer.js